import { useAppContext } from "../context/AppContext";
import translations from "../translations/translations.json";

export const useTranslation = () => {
  const { language } = useAppContext();

  const getTranslation = (key: string): string => {
    // Attempt to get the translation in the current language
    const translation = translations[language]?.[key];

    // Fallback to English if the key doesn't exist in the current language
    if (!translation) {
      return translations["en"]?.[key] || key;
    }

    return translation;
  };

  return { getTranslation };
};
